








export default {
  name: "Card",
  props: {
    title: String,
    bordered: Boolean,
    customStyle: String,
    customCardStyle: String,
  },
  data() {
    return {
      headStyle: {
        borderBottom: "none",
        fontSize: "20px",
        fontWeight: 500,
      },
    };
  },
};
